<template>
  <sticky-cta-page :cta-props="{buttonProps: { title: 'בחזרה לתזרים'}}" @click="onContinueClicked">
    <img src="/images/advisory/mislaka-consent-header.svg" />
    <div class="mislaka-finished-connection">
      <div class="padding-horizontal-ml">
        <div class="ri-body top-title margin-top-ml margin-bottom-sm">מעולה! כל החשבונות שלך מחוברים</div>
        <div class="ri-large-headline margin-bottom-xs">סיימנו את השלב הראשון, והתמונה הכלכלית שלך בדרך אלייך.</div>
        <div class="ri-large-body margin-bottom-ml">
          בימים הקרובים נשלח לך לינק בווטסאפ עם כל הקרנות, הפקדונות וההלוואות שלך.
        </div>
        <img src="/images/advisory/mislaka-finished.png" class="margin-bottom-ml image" />
      </div>
    </div>
  </sticky-cta-page>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';

export default {
  name: 'MislakaFinishedConnection',
  components: {
    StickyCtaPage: BaseUI.Pages.StickyCtaPage,
  },
  created() {
    Segment.trackUserGot('MislakaFinishedConnection_Entered');
  },
  methods: {
    onContinueClicked() {
      Segment.trackUserGot('MislakaFinishedConnection_ContinueClicked');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.mislaka-finished-connection{
  height: 100%;
  text-align: right;

  .top-title{
    color: $riseup_blue;
  }

  .image {
    height: 130px;
    width: 150px;
  }
}

</style>
